import { stringify } from "qs";

/**
 * @param {string} url
 * @param {{body?: string|object|FormData, headers?: object, showLoader?: boolean}} [options]
 * @return {Promise}
 */
export function sendRequest(url, options) {
  const self = this;
  options = options || {};

  let ajaxOptions = {
    url: url,
    dataType: "json",
  };

  if (options.headers) ajaxOptions.headers = options.headers;

  if (options.body) {
    if (options.body instanceof FormData) {
      ajaxOptions.processData = false;
      ajaxOptions.contentType = false;
      ajaxOptions.data = options.body;
    } else if (typeof options.body === "object") {
      ajaxOptions.data = stringify(options.body);
    }
  }

  if (options.type) {
    ajaxOptions.type = options.type;
  }

  if (options.showLoader === true && window.ajaxIndicatior) {
    window.ajaxIndicatior.show();
  }

  return new Promise((resolve, reject) => {
    $.ajax(ajaxOptions)
      .done((data) => {
        let resultData = {
          data: data,
          status: 200,
          statusText: "OK",
        };
        resolve(resultData);
      })
      .fail((response) => {
        let error = new Error();
        error.code = response.status;
        error.message = response.statusText;
        error.responseJSON = response.responseJSON;
        reject(error);
      })
      .always(function () {
        if (options.showLoader === true && window.ajaxIndicatior) {
          window.ajaxIndicatior.close();
        }
      });
  });
}

/**
 * @param {string|number} price
 * @return {string}
 */
export function formatPrice(price) {
  let result = parseFloat(price);

  if (!isNaN(result) && isFinite(result))
    result = result.toLocaleString("ru-Ru", { maximumFractionDigits: 2 });
  else result = "";

  if (/\.$/.test(price)) result += ",";
  return result;
}

export function formatDate(date) {
  let monthNumber = date.getMonth() + 1;
  if (monthNumber.toString().length == 1) {
    monthNumber = "0" + monthNumber;
  }
  return date.getDate() + "." + monthNumber + "." + date.getFullYear();
}

export function formatPriceWithSymbol(price, symbol = "₽", delimeter = " ") {
  return formatPrice(price) + delimeter + symbol;
}

export function getDeviceStatusLabel(code, deviceCodes) {
  for (let deviceCode of deviceCodes) {
    if (parseInt(deviceCode.value) == parseInt(code)) {
      return deviceCode.label;
    }
  }
  return "";
}

export function calcDaysBetweenDateStrings(date1, date2 = null) {
  let dateObject2;
  if (date2) {
    dateObject2 = getDateFromString(date2);
  } else {
    dateObject2 = new Date();
  }
  let dateObject1 = getDateFromString(date1);
  return Math.floor(
    (dateObject2.getTime() - dateObject1.getTime()) / (1000 * 3600 * 24)
  );
}

export function calcDaysBetweenDates(date1, date2 = null) {
  if (!date2) {
    date2 = new Date();
  }
  return Math.floor((date2.getTime() - date1.getTime()) / (1000 * 3600 * 24));
}

export function getDateFromString(dateString, delimeter = ".") {
  let dateParts = dateString.split(delimeter);
  return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
}

export function makeDetailsInfoByValues(
  device,
  details,
  sumToPayDevice = null,
  sumToPayTotal = null
) {
  let deviceSum = sumToPayDevice ? sumToPayDevice : device.sum;
  let totalSum = sumToPayTotal ? sumToPayTotal : details.sumToPayCalc;
  let dataValue = [
    {
      field: "Показание текущее",
      value: device.val2,
    },
    {
      field: "Дата",
      value: device.date2,
    },
    {
      field: "Источник",
      value: device.source2,
    },
    {
      field: "Показания предыдущие",
      value: device.val1,
    },
    {
      field: "Дата предыдущих показаний",
      value: device.date1,
    },
    {
      field: "Источник предудущих показаний",
      value: device.source1,
    },
    {
      field: "Расход с текущего по предыдущее",
      value: device.vol + " кВтч",
    },
    {
      field: "Действующий тариф",
      value: device.taxacur,
    },
    {
      field: "Начислено",
      value: formatPriceWithSymbol(deviceSum),
    },
    {
      field: "К оплате",
      value: formatPriceWithSymbol(totalSum),
    },
  ];
  return dataValue;
}

export function getDateOfPrevPeriod(lastDayOfPeriod = 26) {
  let date = new Date();
  let today = date.getDate();
  let lastDate = new Date();
  if (today <= lastDayOfPeriod) {
    lastDate.setMonth(lastDate.getMonth() - 1);
  }
  lastDate.setDate(lastDayOfPeriod);
  return lastDate;
}

export function makeDetailsInfoCalc(device, details) {
  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  var lastDay = new Date(y, m, 26);
  let lastDayOfPeriod = getDateOfPrevPeriod();
  let lastDayOfPeriodFormatted =
    lastDayOfPeriod.getDate() +
    "." +
    (lastDayOfPeriod.getMonth() + 1) +
    "." +
    lastDayOfPeriod.getFullYear();
  let rvol = device.vol && device.vol != "" ? device.vol : 0;
  let rsum = device.sum && device.sum != "" ? device.sum : 0;
  if (details.sumToPayValue > 0 && device.sum > 0) {
  }
  let dataCalc = [
    {
      field: "Показание текущее",
      value: device.val2,
    },
    {
      field: "Дата",
      value: device.date2,
    },
    {
      field: "Источник",
      value: device.source2,
    },
    {
      field: "Количество дней без показаний на конец последнего месяца",
      value:
        calcDaysBetweenDates(getDateFromString(device.date2), lastDayOfPeriod) +
        " дней",
    },
    {
      field:
        "Расчетное потребление с " +
        device.date2 +
        " по " +
        formatDate(lastDayOfPeriod),
      value: rvol + " кВтч",
    },
    {
      field: "Расчетное начисление",
      value:
        parseFloat(rvol) +
        " * " +
        device.taxacur +
        " = " +
        formatPriceWithSymbol(parseFloat(rsum)),
    },
  ];
  return dataCalc;
}

export function makeDevicesInfo(devices, lastPay = null) {
  let devicesInfo = [];
  var date = new Date();
  devices.map((device) => {
    let newItem = {
      id: device.serial,
      status: device.state,
      lastValue: device.val2,
      source: device.source2,
    };
    let daysWithoutValues = calcDaysBetweenDateStrings(
      device.date2,
      formatDate(date)
    );
    let data = [
      {
        name: "lastValue",
        title: "Последние показания",
        value: device.val2,
        additional: "от " + device.date2,
      },
      {
        name: "daysWithoutValues",
        title: "Количество дней без показаний",
        value: daysWithoutValues,
      },
      {
        name: "source",
        title: "Источник",
        value: device.source2,
      },
    ];
    if (lastPay) {
      let lastPayInfo = {
        name: "lastPay",
        title: "Последняя оплата",
        value: lastPay.value + " ₽",
        additional: "от " + lastPay.date,
      };
      data.push(lastPayInfo);
    }
    newItem.data = data;
    devicesInfo.push(newItem);
  });
  return devicesInfo;
}
/**
 * @param {number} amount
 * @param {{commissionAbsolute: number, commissionPercent: number, commissionMinValue: number, commissionMaxValue: number}} service
 * @return {number}
 */
export function calcCommisionBySppsService(amount, service) {
  return calcComission(
    amount,
    service.commissionAbsolute,
    service.commissionPercent,
    service.commissionMinValue,
    service.commissionMaxValue
  );
}

export function calcComission(
  amount,
  comissionAbsolute,
  comissionPercent,
  comissionMin,
  comissionMax
) {
  let comission = 0;

  amount = parseFloat(amount);
  if (amount <= 0) {
    return comission;
  }

  comissionAbsolute = parseFloat(comissionAbsolute);
  comissionPercent = parseFloat(comissionPercent);
  comissionMin = parseFloat(comissionMin);
  comissionMax = parseFloat(comissionMax);

  if (comissionAbsolute > 0) {
    comission = comissionAbsolute;
  } else if (comissionPercent > 0) {
    comission = amount * (comissionPercent / 100);
    if (comissionMin > 0) {
      comission = Math.max(comission, comissionMin);
    }
    if (comissionMax > 0) {
      comission = Math.min(comission, comissionMax);
    }
  }

  return comission;
}

export function prettyPhase(phase) {
  if (!phase) return null;
  switch (phase) {
    case 1:
      return "Однофазный";
    case 2:
      return "Двухфазный";
    case 3:
      return "Трёхфазный";
  }

  return phase + "-фазный";
}

let totalBlockOffsetTop = null;

export function checkEmail(email) {
  return /^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
    email
  );
}

export function stickyPayBlock() {
  window.addEventListener("scroll", () => {
    const totalBlock = document.querySelector(".debt-total-section");
    const debtForm = document.getElementById("preact-debts-form");
    const totalBlockWrapper = document.querySelector(".total-block-wrapper");

    if (totalBlock && debtForm && totalBlockWrapper) {
      const totalBlockBoundingRect = totalBlock.getBoundingClientRect();
      const debtFormBoundingRect = debtForm.getBoundingClientRect();

      if (!totalBlockOffsetTop) {
        totalBlockOffsetTop = totalBlock.offsetTop;
      }
      let wrapperWidth = totalBlockWrapper.clientWidth;
      let windowScrollTop = window.scrollY + 32;
      let maxScrollTop =
        debtForm.offsetTop +
        debtFormBoundingRect.height -
        totalBlockBoundingRect.height -
        32;
      if (window.innerWidth >= 992) {
        if (windowScrollTop < maxScrollTop) {
          totalBlockWrapper.classList.remove("align-bottom");
          if (windowScrollTop >= totalBlockOffsetTop) {
            totalBlock.classList.add("fixed");
            totalBlock.style.maxWidth = wrapperWidth + "px";
          } else {
            totalBlock.classList.remove("fixed");
            delete totalBlock.style;
          }
        } else {
          totalBlock.classList.remove("fixed");
          totalBlockWrapper.classList.add("align-bottom");
        }
      }
    }
  });
}

export function getErrorRequestMessage(error) {
  if (
    typeof error.responseJSON === "object" &&
    !!error.responseJSON.error &&
    Array.isArray(error.responseJSON.error)
  ) {
    if (error.responseJSON.error[0] === "CREATE_ORDER_DISABLED") {
      return "Приём платежей временно отключен по техническим причинам.";
    }
  }
  if (
    typeof error.responseJSON === "object" &&
    !!error.responseJSON.code && 
    error.responseJSON.code === 1000 //UserEmailIsEmptyException
  ) {
    if (!!error.responseJSON.message) {
      return error.responseJSON.message;
    }
  }

  return "Произошла неизвестная ошибка во время выполнения запроса.<br>Пожалуйста, обратитесь в техподдержку.";
}

export function validateNumEgrn(number)
{
	const pattern = /^[0-9.\/-]+$/g;
	return pattern.test(number);
}

export function validateDate(str)
{
	const input = str.match(/\d+/g),
		date = new Date(input[2], input[1] - 1, input[0]);

	return date.getFullYear() > 1900
	    && date.getFullYear() === parseInt(input[2])
		&& date.getDate()     === parseInt(input[0])
		&& date.getMonth()    === parseInt(input[1]) - 1;
}

export function validateEmail(email){
	const pattern = /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/g;
	return pattern.test(email);
}

export const validateDeniedType = (allowedFileTypes) => (file) => {
	const name = file.name.split('.');
	const type = name[name.length - 1].toLocaleLowerCase();
	return !allowedFileTypes.includes(type);
}

export function validateEmptyFile(file){
	return file.size === 0;
}

export function formatSize(length){
	const type = ['б', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб'];
	let i = 0;
	while((length / 1000 | 0) && i < type.length - 1)
	{
		length /= 1024;
		i++;
	}
	const fractionDigits = (i < 1 || parseInt(length) === length) ? 0 : 2;
	return length.toFixed(fractionDigits) + ' ' + type[i];
}

export const validateBigFile = (fileSize) => (file) => 	file.size > fileSize;

export function isEmpty(obj) {
	for(let key in obj)
	{
		return false;
	}
	return true;
}

export function validateByPattern(value, pattern, field, fieldName)
{
	let errors = {};

	if(value && value.length)
	{
		if(pattern.test(value))
		{
			errors[field] = '"' + fieldName + '" содержит недопустимые символы';
		}
	}

	return errors;
}

let lastCall;
let lastCallTimer;

export function debounce(f, t){
	return function(args){
		let previousCall = lastCall;
		lastCall = Date.now();

		if(previousCall && ((lastCall - previousCall) <= t))
		{
			clearTimeout(lastCallTimer);
		}
		lastCallTimer = setTimeout(() => f(args), t);
	}
}

export function validateFiles (files, maxCountFile, maxSizeFile, allowedFileTypes) {
  let errors = {};

  if (!files.length) return errors;

  if (files.length > maxCountFile)
  {
    errors.manyFiles = 'Нельзя отправить более '+maxCountFile+' файлов';
  }

  if (files.some(validateBigFile(maxSizeFile)))
  {
    errors.hasBigFiles = 'Ограничение на размер файлов ' + formatSize(maxSizeFile);
  }

  if (files.some((item => item.size === 0)))
  {
    errors.hasEmptyFiles = 'Нельзя отправить пустой файл';
  }

  if (files.some(validateDeniedType(allowedFileTypes)))
  {
    errors.filesDeniedType = 'Допустимый формат файлов: ' + allowedFileTypes.join(', ');
  }

  return errors;
}